var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_190_12521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5638 23.6795C9.8028 24.4781 10.293 25.1784 10.9617 25.6763C11.6303 26.1741 12.4417 26.443 13.2754 26.443C14.109 26.443 14.9204 26.1741 15.5891 25.6763C16.2577 25.1784 16.748 24.4781 16.9869 23.6795H9.5638ZM3.31885 22.5732H23.2319V19.2544L21.0193 15.9355V10.4041C21.0193 9.38717 20.819 8.38018 20.4299 7.44064C20.0407 6.50109 19.4703 5.64741 18.7512 4.92831C18.0321 4.20922 17.1784 3.6388 16.2389 3.24963C15.2993 2.86046 14.2923 2.66016 13.2754 2.66016C12.2584 2.66016 11.2514 2.86046 10.3119 3.24963C9.37235 3.6388 8.51866 4.20922 7.79956 4.92831C7.08047 5.64741 6.51005 6.50109 6.12088 7.44064C5.73171 8.38018 5.53141 9.38717 5.53141 10.4041V15.9355L3.31885 19.2544V22.5732Z",
    fill: "#CD2A3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_190_12521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.5507,
    height: 26.5507,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.9f44ebfbcefe675a9b16f1ed3d85f10f.svg";
export { ForwardRef as ReactComponent };